export enum TrackingEntityType {
	STUDY = 'study',
	ORGANISATION = 'organisation',
}
